<template>
  <v-app>
    <AppLayout style="overflow: hidden;" />
  </v-app>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { global_store } from '@/store';
import { debounce } from '@/utils';
import AppLayout from './layouts/components/AppLayout.vue';

const { mutations } = global_store;

@Component({
  components: {
    AppLayout,
  },
})
export default class App extends Vue {
  mounted() {
    const debounced_resize = () => {
      const client_width = document.documentElement.clientWidth;

      if (client_width > 1264) {
        return mutations.SET_DESKTOP_WIDTH();
      } if (client_width <= 1264 && client_width > 959) {
        return mutations.SET_LAPTOP_WIDTH();
      } if (client_width <= 959 && client_width > 599) {
        return mutations.SET_TABLET_WIDTH();
      }
      return mutations.SET_MOBILE_WIDTH();
    };

    debounced_resize();
    window.onresize = debounce(debounced_resize, 200);
  }
}
</script>

<style module lang="scss">

</style>
